<a  (click)="emit_onClick($event)">
    <app-image-box
        (loaded)="emit_onLoaded()"
        [matTooltip]="tooltip$$()"
        [matTooltipPosition]="tooltipPosition$$()"
        [url]="url$$()"
        [guid]="guid$$()"
        [version]="version$$()"
        [border]="border$$()"
        [highlight]="highlight$$()"
    >
        <ng-content />
    </app-image-box>
</a>